import { PageActionBar } from "components/PageActionBar";
import { useOrderReadiness } from "pages/CreateOrder/hooks/useOrderReadiness";
import { ReactNode } from "react";

/** The order pages' action bar: the shared sticky bar plus the readiness hint. */
export function StickyFooter({ children }: { children: ReactNode }) {
  const isReady = useOrderReadiness();

  return (
    <PageActionBar>
      <span className="footer-hint" data-testid="pageActionsHint">
        {isReady
          ? "Ready to generate and send"
          : "Please, fill in all required fields to create estimate"}
      </span>

      {children}
    </PageActionBar>
  );
}
